/**
 * How often queries that poll should refetch
 */
export const default_refetch_interval_ms = 5000
